import { clsx, type ClassValue } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

// tailwind-merge must know our custom font-size tokens (text-md) and radius/shadow names,
// otherwise `text-md text-text-muted` is treated as a conflict and one class is dropped.
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: ['md'],
      radius: ['control', 'card', 'dialog'],
      shadow: ['card', 'control', 'popover', 'dialog', 'bar'],
    },
  },
})

/** Merge class names; later Tailwind utilities win over earlier conflicting ones. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
